module.exports = __webpack_public_path__ + "b86380d30ce3ce0219e6f78447ce8f67.png";